const deleteExecutorTypeDenied = {
    title: 'Ошибка удаления',
    description: 'Нельзя удалить категорию, если в системе есть исполнители с ней',
} as const;

export default deleteExecutorTypeDenied;
